window.notificationRowStyle = function(row, index) {
    switch (row.type) {
        case "App\\Notifications\\Monitoring\\Task\\Failed":
            return {
                css: {
                    background: '#F9C2B0',
                    color: '#A52714'
                }
            }
        default:
            return {}
    }
}
